"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.size = void 0;
const foundation_1 = require("../foundation");
exports.size = {
    corner_radius: {
        ids_size_cornerRadius_button: foundation_1.foundation_size.tiny.size_tiny_8,
        ids_size_cornerRadius_smallButton: foundation_1.foundation_size.tiny.size_tiny_8,
        ids_size_cornerRadius_tags_01: foundation_1.foundation_size.tiny.size_tiny_4,
        ids_size_cornerRadius_fab: foundation_1.foundation_size.small.size_small_12,
        ids_size_cornerRadius_tags_02: foundation_1.foundation_size.tiny.size_tiny_4,
        ids_size_cornerRadius_tooltip: foundation_1.foundation_size.tiny.size_tiny_4,
        ids_size_cornerRadius_card_01: foundation_1.foundation_size.small.size_small_12,
        ids_size_cornerRadius_card_02: foundation_1.foundation_size.small.size_small_12,
        ids_size_cornerRadius_layout_01: foundation_1.foundation_size.small.size_small_16,
        ids_size_cornerRadius_layout_02: foundation_1.foundation_size.small.size_small_24,
        ids_size_cornerRadius_password_code: foundation_1.foundation_size.tiny.size_tiny_8,
    },
    border_width: {
        ids_size_border_small: foundation_1.foundation_size.tiny.size_tiny_1,
        ids_size_border_medium: foundation_1.foundation_size.tiny.size_tiny_2,
        ids_size_border_large: foundation_1.foundation_size.tiny.size_tiny_4,
    },
    general: {
        ids_size_general_1x: foundation_1.foundation_size.tiny.size_tiny_1,
        ids_size_general_2x: foundation_1.foundation_size.tiny.size_tiny_2,
        ids_size_general_3x: foundation_1.foundation_size.tiny.size_tiny_3,
        ids_size_general_4x: foundation_1.foundation_size.tiny.size_tiny_4,
        ids_size_general_5x: foundation_1.foundation_size.tiny.size_tiny_5,
        ids_size_general_6x: foundation_1.foundation_size.tiny.size_tiny_6,
        ids_size_general_7x: foundation_1.foundation_size.tiny.size_tiny_7,
        ids_size_general_8x: foundation_1.foundation_size.tiny.size_tiny_8,
        ids_size_general_10x: foundation_1.foundation_size.small.size_small_10,
        ids_size_general_12x: foundation_1.foundation_size.small.size_small_12,
        ids_size_general_14x: foundation_1.foundation_size.small.size_small_14,
        ids_size_general_16x: foundation_1.foundation_size.small.size_small_16,
        ids_size_general_18x: foundation_1.foundation_size.small.size_small_18,
        ids_size_general_20x: foundation_1.foundation_size.small.size_small_20,
        ids_size_general_22x: foundation_1.foundation_size.small.size_small_22,
        ids_size_general_24x: foundation_1.foundation_size.small.size_small_24,
        ids_size_general_28x: foundation_1.foundation_size.medium.size_medium_28,
        ids_size_general_30x: foundation_1.foundation_size.medium.size_medium_30,
        ids_size_general_32x: foundation_1.foundation_size.medium.size_medium_32,
        ids_size_general_36x: foundation_1.foundation_size.medium.size_medium_36,
        ids_size_general_40x: foundation_1.foundation_size.medium.size_medium_40,
        ids_size_general_44x: foundation_1.foundation_size.medium.size_medium_44,
        ids_size_general_48x: foundation_1.foundation_size.medium.size_medium_48,
        ids_size_general_52x: foundation_1.foundation_size.medium.size_medium_52,
        ids_size_general_56x: foundation_1.foundation_size.medium.size_medium_56,
        ids_size_general_60x: foundation_1.foundation_size.medium.size_medium_60,
        ids_size_general_64x: foundation_1.foundation_size.large.size_large_64,
        ids_size_general_68x: foundation_1.foundation_size.large.size_large_68,
        ids_size_general_72x: foundation_1.foundation_size.large.size_large_72,
        ids_size_general_76x: foundation_1.foundation_size.large.size_large_76,
        ids_size_general_80x: foundation_1.foundation_size.large.size_large_80,
        ids_size_general_84x: foundation_1.foundation_size.large.size_large_84,
        ids_size_general_88x: foundation_1.foundation_size.large.size_large_88,
        ids_size_general_92x: foundation_1.foundation_size.large.size_large_92,
        ids_size_general_96x: foundation_1.foundation_size.large.size_large_96,
        ids_size_general_100x: foundation_1.foundation_size.large.size_large_100,
        ids_size_general_104x: foundation_1.foundation_size.xlarge.size_xlarge_104,
        ids_size_general_108x: foundation_1.foundation_size.xlarge.size_xlarge_108,
        ids_size_general_112x: foundation_1.foundation_size.xlarge.size_xlarge_112,
        ids_size_general_116x: foundation_1.foundation_size.xlarge.size_xlarge_116,
        ids_size_general_120x: foundation_1.foundation_size.xlarge.size_xlarge_120,
        ids_size_general_124x: foundation_1.foundation_size.xlarge.size_xlarge_124,
        ids_size_general_128x: foundation_1.foundation_size.xlarge.size_xlarge_128,
        ids_size_general_132x: foundation_1.foundation_size.xlarge.size_xlarge_132,
        ids_size_general_136x: foundation_1.foundation_size.xlarge.size_xlarge_136,
        ids_size_general_140x: foundation_1.foundation_size.xlarge.size_xlarge_140,
    },
};
//# sourceMappingURL=size.js.map